import type { Page } from '@reolink-web/bff-framework-press/client';

const sharedModule = {
    onRenderIsomorphic(_ctx, props) {
        return props;
    },
} satisfies Page.IPageSharedModule<unknown, unknown>;

export default sharedModule;
